// Typed shim over the untyped shadcn .jsx components so TS files get relaxed props.
import React from "react";
import { Button as _Button } from "./ui/button";
import { Input as _Input } from "./ui/input";
import { Textarea as _Textarea } from "./ui/textarea";
import { Label as _Label } from "./ui/label";
import { Checkbox as _Checkbox } from "./ui/checkbox";
import { Progress as _Progress } from "./ui/progress";
import { Toaster as _Toaster } from "./ui/sonner";
import {
  InputOTP as _InputOTP,
  InputOTPGroup as _InputOTPGroup,
  InputOTPSlot as _InputOTPSlot,
} from "./ui/input-otp";
import {
  Select as _Select,
  SelectContent as _SelectContent,
  SelectItem as _SelectItem,
  SelectTrigger as _SelectTrigger,
  SelectValue as _SelectValue,
} from "./ui/select";
import {
  Accordion as _Accordion,
  AccordionContent as _AccordionContent,
  AccordionItem as _AccordionItem,
  AccordionTrigger as _AccordionTrigger,
} from "./ui/accordion";
import {
  Tabs as _Tabs,
  TabsContent as _TabsContent,
  TabsList as _TabsList,
  TabsTrigger as _TabsTrigger,
} from "./ui/tabs";
import { ScrollArea as _ScrollArea, ScrollBar as _ScrollBar } from "./ui/scroll-area";
import {
  Dialog as _Dialog,
  DialogContent as _DialogContent,
  DialogDescription as _DialogDescription,
  DialogFooter as _DialogFooter,
  DialogHeader as _DialogHeader,
  DialogTitle as _DialogTitle,
  DialogTrigger as _DialogTrigger,
} from "./ui/dialog";
import {
  DropdownMenu as _DropdownMenu,
  DropdownMenuCheckboxItem as _DropdownMenuCheckboxItem,
  DropdownMenuContent as _DropdownMenuContent,
  DropdownMenuItem as _DropdownMenuItem,
  DropdownMenuLabel as _DropdownMenuLabel,
  DropdownMenuSeparator as _DropdownMenuSeparator,
  DropdownMenuTrigger as _DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { Skeleton as _Skeleton } from "./ui/skeleton";

type AnyFC = React.ComponentType<any>;

export const Button = _Button as AnyFC;
export const Input = _Input as AnyFC;
export const Textarea = _Textarea as AnyFC;
export const Label = _Label as AnyFC;
export const Checkbox = _Checkbox as AnyFC;
export const Progress = _Progress as AnyFC;
export const Toaster = _Toaster as AnyFC;
export const InputOTP = _InputOTP as AnyFC;
export const InputOTPGroup = _InputOTPGroup as AnyFC;
export const InputOTPSlot = _InputOTPSlot as AnyFC;
export const Select = _Select as AnyFC;
export const SelectContent = _SelectContent as AnyFC;
export const SelectItem = _SelectItem as AnyFC;
export const SelectTrigger = _SelectTrigger as AnyFC;
export const SelectValue = _SelectValue as AnyFC;
export const Accordion = _Accordion as AnyFC;
export const AccordionContent = _AccordionContent as AnyFC;
export const AccordionItem = _AccordionItem as AnyFC;
export const AccordionTrigger = _AccordionTrigger as AnyFC;
export const Tabs = _Tabs as AnyFC;
export const TabsContent = _TabsContent as AnyFC;
export const TabsList = _TabsList as AnyFC;
export const TabsTrigger = _TabsTrigger as AnyFC;
export const ScrollArea = _ScrollArea as AnyFC;
export const ScrollBar = _ScrollBar as AnyFC;
export const Dialog = _Dialog as AnyFC;
export const DialogContent = _DialogContent as AnyFC;
export const DialogDescription = _DialogDescription as AnyFC;
export const DialogFooter = _DialogFooter as AnyFC;
export const DialogHeader = _DialogHeader as AnyFC;
export const DialogTitle = _DialogTitle as AnyFC;
export const DialogTrigger = _DialogTrigger as AnyFC;
export const DropdownMenu = _DropdownMenu as AnyFC;
export const DropdownMenuCheckboxItem = _DropdownMenuCheckboxItem as AnyFC;
export const DropdownMenuContent = _DropdownMenuContent as AnyFC;
export const DropdownMenuItem = _DropdownMenuItem as AnyFC;
export const DropdownMenuLabel = _DropdownMenuLabel as AnyFC;
export const DropdownMenuSeparator = _DropdownMenuSeparator as AnyFC;
export const DropdownMenuTrigger = _DropdownMenuTrigger as AnyFC;
export const Skeleton = _Skeleton as AnyFC;
